/**
 * Copyright 2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { Button } from "@nordcloud/gnui";
import { AuditLog } from "~/generated/graphql";
import { useDisclosure } from "~/hooks";
import { AuditLogDetailsSidebar } from "./AuditLogDetailsSidebar";

type Props = {
  auditLog: AuditLog;
};

export function AuditLogDetailsButton({ auditLog }: Props) {
  const {
    isOpen: isAuditLogDetailsSidebarOpen,
    open: openAuditLogDetailsSidebar,
    close: closeAuditLogDetailsSidebar,
  } = useDisclosure();

  return (
    <>
      <Button
        icon="search"
        severity="low"
        onClick={openAuditLogDetailsSidebar}
        size="md"
      />
      <AuditLogDetailsSidebar
        isOpen={isAuditLogDetailsSidebarOpen}
        close={closeAuditLogDetailsSidebar}
        auditLog={auditLog}
      />
    </>
  );
}
